import React from 'react';
import {
  Box,
  createStyles,
  Grid,
  Text,
  Title,
} from '@mantine/core';
import {
  IconDeviceLaptop,
  IconServer2,
  IconSettings,
  IconRobot,
} from '@tabler/icons';
import { useTranslation } from 'react-i18next';
import Projects from '../../../Projects';

const useStyles = createStyles((theme) => ({
  generalBox: {
    marginBlock: theme.spacing.sm,
  },
}));

interface ExperienceProfessionalTKWWProps {
  [x: string]: any,
}

export default function ExperienceProfessionalTKWW(
  { ...props }: ExperienceProfessionalTKWWProps,
) {
  const { theme } = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'experience.content.professional.content.tkww.contents.technologies' });

  const frontendItems = t('frontend.paragraphs', {
    returnObjects: true,
    defaultValue: [],
  }) as string[];

  const aiItems = t('ai.paragraphs', {
    returnObjects: true,
    defaultValue: [],
  }) as string[];

  const backendItems = t('backend.paragraphs', {
    returnObjects: true,
    defaultValue: [],
  }) as string[];

  const otherItems = t('other.paragraphs', {
    returnObjects: true,
    defaultValue: [],
  }) as string[];

  return (
    <Box {...props}>
      <Projects i18nKey="experience.content.professional.content.tkww.contents.projects" />
      <Title order={4} align="center" sx={{ padding: 0, marginBottom: theme.spacing.sm }}>
        {t('title')}
      </Title>
      <Grid justify="space-between" className="border-gradient" grow>
        <Grid.Col xs={3}>
          <Title order={5} align="left">
            {t('frontend.title')}
            {' '}
            <IconDeviceLaptop />
          </Title>
          {frontendItems.map((item) => (
            <Text key={item} size="sm">{item}</Text>
          ))}
        </Grid.Col>
        <Grid.Col xs={3}>
          <Title order={5} align="left">
            {t('ai.title')}
            {' '}
            <IconRobot />
          </Title>
          {aiItems.map((item) => (
            <Text key={item} size="sm">{item}</Text>
          ))}
        </Grid.Col>
        <Grid.Col xs={3}>
          <Title order={5} align="left">
            {t('backend.title')}
            {' '}
            <IconServer2 />
          </Title>
          {backendItems.map((item) => (
            <Text key={item} size="sm">{item}</Text>
          ))}
        </Grid.Col>
        <Grid.Col xs={3}>
          <Title order={5} align="left">
            {t('other.title')}
            {' '}
            <IconSettings />
          </Title>
          {otherItems.map((item) => (
            <Text key={item} size="sm">{item}</Text>
          ))}
        </Grid.Col>
      </Grid>
    </Box>
  );
}
